import "bootstrap/dist/css/bootstrap.min.css";
import React from "react";
import { useTranslation } from "react-i18next";
import footerLogo from "../../assets/img/tajinvestSmall3.png";
import tgIcon from "../../assets/img/telegramIcon.svg";
import "./style.css";
import Emblem from "../../assets/img/EmblemTj.svg";

function Footer() {
  const { t } = useTranslation();

  return (
    <div className="footerBody fontWhite">
      <div className="container">
        <div className="row footerLinks pt-4 pb-2">
          <div className="col-12 col-md-3 d-flex align-items-start justify-content-center justify-content-md-start gap-3 mb-4 mb-md-0">
            <div className="emblem-wrapper">
              <img src={Emblem} alt="Emblem" className="emblem-img" />
              <span className="emblem-title">{t("emblemTitle")}</span>
            </div>
            <div className="emblem-block">
              <img src={footerLogo} className="emblem-img" alt="Main logo" />
              <span className="emblem-text">{t("logoTitle")}</span>
              <span className="emblem-text">{t("logoTaj")}</span>
            </div>
          </div>
          <div className="col-6 col-md-2 text-center text-md-start mb-3 mb-md-0">
            <a href="/">{t("home")}</a>
            <a href="/maps">{t("projectCoverageMapMenu")}</a>
          </div>
          <div className="col-6 col-md-2 text-center text-md-start mb-3 mb-md-0">
            <a href="/deatel">DISCOVER TAJIKISTAN</a>
            <a href="/structure">{t("leadership")}</a>
            <a href="/job">{t("vacancies")}</a>
          </div>
          <div className="col-12 col-md-2 text-center text-md-start mb-3 mb-md-0">
            <a href="/news">{t("news")}</a>
            <a href="/competitions">{t("announcements")}</a>
          </div>
          <div className="col-12 col-md-3 mb-4 mb-md-0">
            <div className="map-container">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d3119.3073402355813!2d68.7868114232788!3d38.572769775972496!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x38b5d15d98b9788b%3A0x4bc5c4b14e9310d3!2z0L_RgNC-0YHQv9C10LrRgiDQoNGD0LTQsNC60LggNDAsINCU0YPRiNCw0L3QsdC1!5e0!3m2!1sru!2s!4v1758692331445!5m2!1sru!2s"
                className="google-map"
                allowFullScreen=""
                aria-hidden="false"
                tabIndex="0"
                title="Google Map"
              />
            </div>
          </div>
          <div className="col-12 text-center text-md-start address-section mt-3 mt-md-4 pb-4">
            <div className="row">
              <div className="col-12 col-md-6">
                <div>
                  {t("address")}
                  <br />
                  <div className="contact-line d-flex flex-wrap">
                    <span>{t("phone")}</span>
                    <span className="fw-semibold">(+992) 988 71 13 05</span>
                    <a
                      href="https://t.me/TajinvestTajikistan"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="telegram-link"
                      title="Telegram"
                    >
                      <img src={tgIcon} alt="oops" className="tg-icon" />
                    </a>
                  </div>
                  <br />
                  {t("emaill")}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="footerBottom">
        <div className="container">
          <div className="row footerLinks py-3">
            <div className="col-12 col-md-6 text-center text-md-start order-2 order-md-1 mb-2 mb-md-0">
              Copyright 2025
            </div>
            <div className="col-12 col-md-6 text-center text-md-end order-1 order-md-2">
              <a
                href="https://idev42.com/"
                target="_blank"
                rel="noopener noreferrer"
              >
                IDev42
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Footer;
